const SIDEBAR_MENU = {
  home: 'Início',
  orders: 'Pedidos',
  datesAvailability: 'Agenda de Disponibilidade',
  pendingOrders: 'Pendentes',
  scheduledOrders: 'Programados',
  map: 'Mapa',
  history: 'Histórico',
  stock: 'Estoque de Produtos',
  products: 'Produtos',
  onSale: 'Promoções',
  performance: 'Desempenho',
  financial: 'Financeiro',
  management: 'Gerenciamento',
  financialReport: 'Relatórios Financeiros',
  onlinePayment: 'Pagamento Online',
  markup: 'Markup',
  fleetManagement: 'Gestão de frota',
  myAccount: 'Minha Conta',
  dynamicRadius: 'Raio Dinâmico',
  partnerGuide: 'Portal do Parceiro',
  faq: 'Dúvidas',
  logout: 'Sair',
  hideMenu: 'Esconder menu',
  showMenu: 'Abrir menu',
  burgerMenu: 'menu hamburguer',
  submenuOpen: 'Expandir submenu',
  submenuClose: 'Colapsar submenu',
  logo: 'logo Zé Delivery',
  newTag: 'NOVO',
  coupon: 'Gestão de Cupons',
}

export default SIDEBAR_MENU
